import { View } from "@/components/ui/view";
import { GlobalState } from '@/containers/GlobalState';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import ReactFlow, { Background, useNodesInitialized, useReactFlow, applyNodeChanges } from 'reactflow';
import { MediaContext } from '../media/MediaContext';
import * as MediaSelector from "../../../components/media/MediaSelector";
import WorkflowStartNode from '../nodes/WorkflowStartNode';
import EndNode from '../nodes/EndNode';
import WaitNode from "../nodes/WaitNode";
import DecideNode from "../nodes/DecideNode";
import ChecklistNode from "../nodes/ChecklistNode";
import DoNode from "../nodes/DoNode";
import EditWorkflowModal from "../modals/EditWorkflowModal";
import FlowControls from "../basic/FlowControls";
import getLayoutedNodes from "../../algorithms_and_functions/layoutView";


const nodeTypes = {
    workflowStartNode: WorkflowStartNode,
    endNode: EndNode,
    doNode: DoNode,
    waitNode: WaitNode,
    decideNode: DecideNode,
    checklistNode: ChecklistNode
}

export default function ShowFlow({ navigation, flow, editAppWorkflow, allowEdit }) {
    const nodesInitialized = useNodesInitialized();
    const { getNodes, getEdges, setNodes, fitView } = useReactFlow();

    const { inAColors } = useContext(GlobalState);
    const connectionLineStyle = { strokeWidth: 2, stroke: inAColors.primary[900] }

    const [state, setState] = useState(flow)
    const [media, setMedia] = useState({})
    const [showModal, setShowModal] = useState(allowEdit)

    useEffect(() => {
        navigation.setOptions({ title: state.nodes[0].data.title, openModal: allowEdit ? openModal : null, flowId: null })
    }, [state.nodes[0].data.title])

    useEffect(() => {
        let tempMedia = {}
        for (const node of state.nodes) {
            let nodeMedias = {}
            for (const nodeMedia of node.data.media) {
                nodeMedias[nodeMedia] = MediaSelector.imageSrc(nodeMedia, false).uri
            }
            tempMedia[node.id] = nodeMedias
            if (node.data.listElementMedia) {
                for (const elementId of Object.keys(node.data.listElementMedia)) {
                    let elementMedias = {}
                    for (const elementMedia of node.data.listElementMedia[elementId]) {
                        elementMedias[elementMedia] = MediaSelector.imageSrc(elementMedia, false).uri
                    }
                    tempMedia[elementId] = elementMedias
                }
            }
        }
        setMedia(tempMedia)
    }, [])


    useEffect(() => {
        if (nodesInitialized) {
            console.log('ELK', nodesInitialized)
            setTimeout(layoutView, 200)
        }
    }, [nodesInitialized]);

    const openModal = () => {
        setShowModal(true)
    }

    const closeModal = (convert) => {
        if (convert) {
            editAppWorkflow()
        }
        setShowModal(false)
    }

    const layoutView = () => {
        if (nodesInitialized) {
            const layoutNodes = async () => {
                const layoutedNodes = await getLayoutedNodes(
                    getNodes(),
                    getEdges(),
                    'SIMPLE'
                );

                console.log('ELK', layoutedNodes);
                setNodes(layoutedNodes);
                setTimeout(() => fitView(), 100);
            };
            layoutNodes();
        }
    }

    const onNodesChange = useCallback(changes => {
        // console.log('ELK', changes[0].type)
        if (changes[0].type === 'select' || changes[0].type === 'reset' || changes[0].type === 'position') {
            setState(prevState => {
                const newNodes = applyNodeChanges(changes, prevState.nodes)
                return {
                    nodes: newNodes,
                    edges: state.edges
                }
            })
        }
    }, [])

    //console.log('State:', state)
    //console.log('Media:', media)

    return (
        <View className="flex-1">
            <MediaContext.Provider value={{ media, setMedia, flowId: 'showFlow', nodeHighlighting: {} }}>
                <ReactFlow
                    onNodesChange={onNodesChange}
                    nodes={state.nodes}
                    nodeTypes={nodeTypes}
                    edges={state.edges}
                    connectionLineStyle={connectionLineStyle}
                    fitView
                >
                    <Background />
                    <FlowControls />
                </ReactFlow>
            </MediaContext.Provider>
            <EditWorkflowModal showModal={showModal} setShowModal={closeModal} workflowTitle={state.nodes[0].data.title} />
        </View>
    );
}
